import { render } from "./content-field.vue?vue&type=template&id=01fcf481&scoped=true&ts=true"
import script from "./content-field.vue?vue&type=script&lang=ts"
export * from "./content-field.vue?vue&type=script&lang=ts"

import "./content-field.vue?vue&type=style&index=0&id=01fcf481&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fcf481"]])

export default __exports__